export default __webpack_public_path__ + "static/media/copy-icon.28e7ba3e.svg";